// extracted by mini-css-extract-plugin
var _1 = "useValidationWithoutFormikNotifications-modulenotification__PZxbf";
var _2 = "useValidationWithoutFormikNotifications-modulenotifications__MQ5zM NotificationInlineList-moduleNotificationInlineList__oSNpf";
export { _1 as "notification", _2 as "notifications" }
